export const MoneyList = [
  {
    moneyImg: "/images/100k.png",
    title: "100000",
    desc: "Seratus Ribu Rupiah",
    baruDepan: "/images/100k_depan_baru.png",
    baruBelakang: "/images/100k_belakang_baru.png",
    LamaDepan: "/images/100k_depan_lama.png",
    lamaBelakang: "/images/100k_belakang_lama.png",
  },
  {
    moneyImg: "/images/75k.png",
    title: "75000",
    desc: "Tujuh Puluh Lima Ribu Rupiah",
    baruDepan: "/images/75k_depan_baru.png",
    baruBelakang: "/images/75k_belakang_baru.png",
    LamaDepan: "/images/75k_depan_lama.png",
    lamaBelakang: "/images/75k_belakang_lama.png",
  },
  {
    moneyImg: "/images/50k.png",
    title: "50000",
    desc: "Lima Puluh Ribu Rupiah",
    baruDepan: "/images/50k_depan_baru.png",
    baruBelakang: "/images/50k_belakang_baru.png",
    LamaDepan: "/images/50k_depan_lama.png",
    lamaBelakang: "/images/50k_belakang_lama.png",
  },
  {
    moneyImg: "/images/20k.png",
    title: "20000",
    desc: "Dua Puluh Ribu Rupiah",
    baruDepan: "/images/20k_depan_baru.png",
    baruBelakang: "/images/20k_belakang_baru.png",
    LamaDepan: "/images/20k_depan_lama.png",
    lamaBelakang: "/images/20k_belakang_lama.png",
  },
  {
    moneyImg: "/images/10k.png",
    title: "10000",
    desc: "Sepuluh Ribu Rupiah",
    baruDepan: "/images/10k_depan_baru.png",
    baruBelakang: "/images/10k_belakang_baru.png",
    LamaDepan: "/images/10k_depan_lama.png",
    lamaBelakang: "/images/10k_belakang_lama.png",
  },
  {
    moneyImg: "/images/5k.png",
    title: "5000",
    desc: "Lima Ribu Rupiah",
    baruDepan: "/images/5k_depan_baru.png",
    baruBelakang: "/images/5k_belakang_baru.png",
    LamaDepan: "/images/5k_depan_lama.png",
    lamaBelakang: "/images/5k_belakang_lama.png",
  },
  {
    moneyImg: "/images/2k.png",
    title: "2000",
    desc: "Dua Ribu Rupiah",
    baruDepan: "/images/2k_depan_baru.png",
    baruBelakang: "/images/2k_belakang_baru.png",
    LamaDepan: "/images/2k_depan_lama.png",
    lamaBelakang: "/images/2k_belakang_lama.png",
  },
  {
    moneyImg: "/images/1k.png",
    title: "1000",
    desc: "Seribu Rupiah",
    baruDepan: "/images/1k_depan_baru.png",
    baruBelakang: "/images/1k_belakang_baru.png",
    LamaDepan: "/images/1k_depan_lama.png",
    lamaBelakang: "/images/1k_belakang_lama.png",
  },
  {
    moneyImg: "/images/500.png",
    title: "500",
    desc: "Limaratus Rupiah",
    baruDepan: "/images/500_depan_baru.png",
    baruBelakang: "/images/500_belakang_baru.png",
    LamaDepan: "/images/500_depan_lama.png",
    lamaBelakang: "/images/500_belakang_lama.png",
  },
];